import type { ArenaEvent } from '@xox/shared'

/**
 * Opens the arena's Server-Sent-Events feed. `EventSource` reconnects on its own and resends
 * `Last-Event-ID`; we only close it while the tab is hidden and reopen when it comes back (the
 * server replays a recent event, the store dedupes).
 */
export function connectArenaFeed(onEvent: (ev: ArenaEvent) => void): () => void {
  if (typeof EventSource === 'undefined') return () => {}
  let source: EventSource | null = null
  const open = () => {
    if (source) return
    source = new EventSource('/api/arena/events')
    source.onmessage = (e: MessageEvent<string>) => {
      try {
        onEvent(JSON.parse(e.data) as ArenaEvent)
      } catch {
        // ignore malformed frames
      }
    }
  }
  const close = () => {
    source?.close()
    source = null
  }
  const onVisibility = () => (document.hidden ? close() : open())
  open()
  document.addEventListener('visibilitychange', onVisibility)
  return () => {
    document.removeEventListener('visibilitychange', onVisibility)
    close()
  }
}
